import React, { useEffect } from 'react'
import { useGlobalState } from '../providers/GlobalStateProvider'

type Props = {
  header: React.ReactNode
}

export const useTopbarComponent = ({ header }: Props): React.ReactNode => {
  const { topbarComponent, setTopbarComponent } = useGlobalState()

  useEffect(() => {
    setTopbarComponent(
      <div
        style={{
          display: 'flex',
          fontSize: '1rem',
          fontWeight: 600,
          alignItems: 'center',
          color: 'var(--color-gray-900)',
          textTransform: 'capitalize'
        }}
      >
        <span className="">{header}</span>
      </div>
    )

    return () => {
      setTopbarComponent(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [header])

  return topbarComponent
}
